import type { WidgetEventCallback } from '../../../model/widget-base.model';

/**
 * Lightweight event emitter for widget event pub/sub.
 * Provides type-safe event subscription and emission.
 */
export class WidgetEventEmitter {
  private readonly handlers: Map<string, Set<WidgetEventCallback>> = new Map();

  on(event: string, callback: WidgetEventCallback): void {
    if (!this.handlers.has(event)) {
      this.handlers.set(event, new Set());
    }
    this.handlers.get(event)!.add(callback);
  }

  off(event: string, callback: WidgetEventCallback): void {
    const handlers = this.handlers.get(event);
    if (handlers) {
      handlers.delete(callback);
    }
  }

  emit(event: string, data: unknown): void {
    const handlers = this.handlers.get(event);
    if (handlers) {
      handlers.forEach((callback) => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Error in event handler for '${event}':`, error);
        }
      });
    }
  }

  clear(): void {
    this.handlers.clear();
  }
}
